<template>
  <el-dialog class="dialog " customClass="dialog_pr1ograms" :visible="true" :append-to-body="true" :close-on-click-modal="true" @close="elDialogs.relatedJobs = false">
    <div slot="title" class="dialog__head dialog__head_second">
      <div class="dialog__head-inner">
        <h3 class="dialog__title">Редактировать связанные с ПК цифровые документы</h3>
      </div>
    </div>

    <div class="dialog__inner">
      <el-table
          v-if="relatedJobs.length > 0"
          cell-class-name="table__cell"
          class="table table_second"
          header-cell-class-name="table__title"
          :max-height="250"
          ref="table"
          row-key="index"
          :data="this.relatedJobs"
      >
        <el-table-column
            label="Код"
            prop="doc_code"
            :min-width="8"
        />
        <el-table-column
            label="Документ, цифровой ресурс"
            prop="resource"
            :min-width="10"
        />
        <el-table-column
            label="Полное наименование и реквизиты документа (адрес ресурса)"
            prop="doc_name"
            :min-width="16"
        />

        <el-table-column :min-width="8">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" circle @click.prevent="editRelatedJob(scope.$index, scope.row)"></el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" circle @click.prevent="removeRelatedJob(scope.$index, scope.row)"></el-button>
          </template>

        </el-table-column>

      </el-table>

      <div v-else>
        Нет связанных с ПК наименований должностей
      </div>
      <el-divider/>

      <div v-if="showEditForm">
        <el-row :gutter="12" style="margin-bottom: 12px;">
          <el-col :span="6">
            <v-select label="name" v-model="editableRelatedJob.resource" class="select" placeholder="Документ" :options="['ОКЗ', 'ОКВЭД', 'ОКПДТР', 'ЕТКС, ЕКС', 'ОКСО, ОКСВНК', 'ГИР Справочник профессий', 'Иное (указать)']">
            </v-select>
          </el-col>
          <el-col :span="18">
            <validate-input v-model="editableRelatedJob.doc_code" placeholder="Код"/>
          </el-col>
        </el-row>

        <el-row :gutter="12" style="margin-bottom: 12px;">
          <el-col :span="24">
            <validate-input v-model="editableRelatedJob.doc_name" placeholder="Название док-а\ресурса"/>
          </el-col>
        </el-row>

        <el-divider/>

        <el-row align="center" justify="end" :gutter="12">
          <el-button type="danger" plain @click.prevent="cancelEditJob">
            Отменить
          </el-button>
          <el-button type="primary" @click.prevent="saveEditableJob()">
            Сохранить
          </el-button>
        </el-row>
      </div>

      <div v-if="showNewForm">
        <el-row :gutter="12" style="margin-bottom: 12px;">
          <el-col :span="6">
            <v-select label="name" v-model="newRelatedJob.resource" class="select" placeholder="Документ" :options="['ОКЗ', 'ОКВЭД', 'ОКПДТР', 'ЕТКС, ЕКС', 'ОКСО, ОКСВНК', 'ГИР Справочник профессий', 'Иное (указать)']">
            </v-select>
          </el-col>
          <el-col :span="18">
            <validate-input v-model="newRelatedJob.code" placeholder="Код"/>
          </el-col>
        </el-row>

        <el-row :gutter="12" style="margin-bottom: 12px;">
          <el-col :span="8">
            <validate-input v-model="newRelatedJob.name" placeholder="Название док-а\ресурса"/>
          </el-col>

          <el-col :span="6">

          </el-col>

          <el-col :span="10">
            <validate-input v-model="newRelatedJob.requisites" placeholder="Полное наименование и реквизиты документа"/>
          </el-col>
        </el-row>

        <el-divider/>

        <el-row align="center" justify="end" :gutter="12">
            <el-button type="danger" plain @click.prevent="cancelAddingNewJob">
              Отменить
            </el-button>
            <el-button type="primary" @click.prevent="addNewRelatedJob()">
              Добавить
            </el-button>
        </el-row>
      </div>

      <el-button v-if="!showNewForm && !showEditForm" @click="showNewForm = true" type="primary" plain icon="el-icon-plus">
        Добавить цифровой документ
      </el-button>

    </div>
  </el-dialog>
</template>

<script>
import dialog from "@/mixins/dialog";
import {mapActions, mapState} from "vuex";
import ValidateInput from "@/components/ValidateInput";

export default {
  components: {ValidateInput},
  mixins: [ dialog ],
  data() {
    return {
      relatedJobs: [],
      newRelatedJob: {
        resource: '',
        name: '',
        code: '',
        requisites: '',
      },
      showNewForm: false,
      showEditForm: false,
      editableRelatedJob: null,
    }
  },
  name: "RelatedJobDialog",
  methods: {
    ...mapActions('editor', ['CREATE_COMPETENCE', 'UPDATE_COMPETENCE', 'DETACH_COMPETENCE', 'ATTACH_COMPETENCE']),
    async saveEditableJob() {
      let index = this.relatedJobs.indexOf(this.editableRelatedJob);
      this.relatedJobs[index] = this.editableRelatedJob;

      let params = [];
      params['related_jobs'] = this.relatedJobs;
      await this.UPDATE_COMPETENCE({id: this.editableRelatedJob.id, ...this.editableRelatedJob});
    },
    cancelEditJob() {
      this.showEditForm = false;
      this.editableRelatedJob = null;
    },
    async removeRelatedJob(index, row) {
      const jobToRemove = this.relatedJobs.indexOf(index);
      if (index > -1) { // only splice array when item is found
        this.relatedJobs.splice(jobToRemove, 1); // 2nd parameter means remove one item only
      }

      let params = [];
      params['related_jobs'] = this.relatedJobs;

      await this.DETACH_COMPETENCE({qualificationId: this.qualification.id, competenceId: row.id})

    },
    async editRelatedJob(index, row) {
      this.editableRelatedJob = this.relatedJobs[index];
      this.showEditForm = true;
    },
    async addNewRelatedJob() {
      await this.CREATE_COMPETENCE({
        competence: this.newRelatedJob,
        qualificationId: this.qualification.id
      });
    },
    cancelAddingNewJob() {
      this.newRelatedJob = {
        name: '',
        document: '',
        document_name: '',
        code: '',
        requisites: '',
      };
      this.showNewForm = false;
    }
  },
  computed: {
    ...mapState('editor', ['qualification']),
    ...mapState('common', ['panels']),
  },
  mounted() {
    this.relatedJobs = this.qualification.competences;
    Object.assign(this.competences, this.qualification.competences);
  },
  watch: {
    'qualification.competences': function (val) {
      this.relatedJobs = val;
    }
  },
}
</script>
